import { render } from "./FormView.vue?vue&type=template&id=2bc468d8&scoped=true"
import script from "./FormView.vue?vue&type=script&lang=js"
export * from "./FormView.vue?vue&type=script&lang=js"

import "./FormView.vue?vue&type=style&index=0&id=2bc468d8&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/caxias-pedal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc468d8"]])

export default __exports__